// Why an admin closes a user's coaching — sent as `CloseReason` to
// coaching/closeusercoaching. Drives backend logic, e.g. whether the coach is
// paid for the period.
// NOTE: placeholder values defined on the frontend; align with backend once
// the contract is final.
const CoachingCloseReason = {
  CoachUnreachable: 1, // no meeting happened → coach not paid
  NotSatisfied: 2, // meeting(s) happened → coach paid
};

export const CoachingCloseReasonOptions = [
  {
    value: CoachingCloseReason.CoachUnreachable,
    label: "Koça ulaşılamadı / görüşme yapılmadı",
    description: "Koç ile iletişime geçilemedi, görüşme gerçekleşmedi.",
  },
  {
    value: CoachingCloseReason.NotSatisfied,
    label: "Koçtan memnun değilim (görüşme yapıldı)",
    description: "Görüşme gerçekleşti ancak kullanıcı koçtan memnun değil.",
  },
];

export default CoachingCloseReason;
